var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.775,
    height: 27.997,
    viewBox: "0 0 21.775 27.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2590",
    "data-name": "Groupe 2590",
    transform: "translate(-1400.955 -723)",
    opacity: 0.887
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_delete_forever_24px",
    d: "M6.555,27.886A3.12,3.12,0,0,0,9.666,31H22.109a3.12,3.12,0,0,0,3.111-3.111V9.221H6.555Zm3.826-11.074,2.193-2.193,3.313,3.3,3.3-3.3,2.193,2.193-3.3,3.3,3.3,3.3L19.185,25.6l-3.3-3.3-3.3,3.3L10.4,23.406l3.3-3.3ZM21.331,4.555,19.776,3H12L10.444,4.555H5V7.666H26.775V4.555Z",
    transform: "translate(1395.955 720)",
    fill: "rgba(49,61,87,0.92)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a844ae4f73387ceb9a76139462b6bc47.svg";
export { ForwardRef as ReactComponent };